import ServiceableLocationsTotal from '../../stats/ServiceableLocationsTotal';
import ProviderTable from '../../stats/ProviderTable';
import StackedBarChart from '../../stats/StackedBarChart';

const useStyles = ({ width }) => ({
  container: {
    position: 'relative',
    width: `${width}%`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginRight: 20,
    paddingTop: 39,
  },
  chartContainer: {
    position: 'relative',
    width: '100%',
    height: '37%',
    backgroundColor: 'rgb(34, 70, 127)',
    marginBottom: 10,
    borderRadius: 5,
    paddingRight: 5,
  },
});

const DetailsLayoutDesktop = ({ width }) => {
  const styles = useStyles({ width });
  return (
    <div id="details-container" style={styles.container}>
      <ServiceableLocationsTotal />
      <div style={styles.chartContainer}>
        <StackedBarChart />
      </div>
      <ProviderTable />
    </div>
  );
};

export default DetailsLayoutDesktop;
